export default __webpack_public_path__ + "static/media/gallery05.0ac2b34e.jpg";